import { AbortError } from "./abort";
import { internalsField } from "../../common/errors";
import { RequestError } from "./request";
import { TimeoutError } from "./timeout";
import { win } from "../../common/namespaces";

Object.defineProperty(win, internalsField, { value: {} });
win[internalsField].errors = { AbortError, TimeoutError, RequestError };
